const GET_AZURE = 'GET_AZURE';
const GET_AZURE_SUCCESS = 'GET_AZURE_SUCCESS';
const GET_AZURE_ERROR = 'GET_AZURE_ERROR';
const SESSION = "SESSION";
const SESSION_SUCCESS = "SESSION_SUCCESS";
const SESSION_ERROR = "SESSION_ERROR"
export {
  GET_AZURE, GET_AZURE_SUCCESS, GET_AZURE_ERROR, SESSION, SESSION_SUCCESS, SESSION_ERROR

};
